import { createSelector } from 'reselect';
import { getPathName } from 'src/react/common/selectors/getPathName';

export const getIsLocationChanged = createSelector([
    getPathName,
], (pathName) => {
    return pathName.endsWith('/organizations');
});
